import { FC, ReactNode } from 'react';

import { TOrder } from '@/types/orders';

import { useTranslate } from '@/shared/hooks/use-translate';

import * as Styled from './styled';

type TProps = {
    children?: ReactNode;
    handleOpenOffice: () => void;
    order: TOrder;
};

export const GeneralInfo: FC<TProps> = ({ children, handleOpenOffice, order }) => {
    const { t } = useTranslate();

    return (
        <Styled.Wrapper>
            <div className="title">{t('Адрес пункта выдачи')}</div>
            <div className="address" onClick={handleOpenOffice}>
                {order.rentProduct.store.address}
            </div>
            <div className="worktime">{order.rentProduct.store.workTimeSalePoint}</div>
            {children}
        </Styled.Wrapper>
    );
};
